
export const boxShadow = {
  name: 'box-shadow'
}